import React, {useState} from 'react'
import UnderLineInput from '../../../components/input/UnderLineInput'
import WizButton from '../../../components/button/WizButton'

interface IProps {
    className?: string
    onClick?: (e: string) => void
    search?: string
}

const UserSearchContainer: React.FC<IProps> = ({className, onClick, search}) => {
    const [inputText, setInputText] = useState('')
    return (
        <div className={`flex gap-[10px] w-full justify-end ${className}`}>
            <UnderLineInput
                type={'text'}
                inputClassName={'h-full'}
                value={search || inputText}
                onChanged={(e: string) => setInputText(e)}
                onEnterKeyPress={() => onClick(inputText)}
            />

            <WizButton
                text={'Search'}
                size={'small'}
                onClick={() => {
                    onClick(inputText)
                }}
            />
            <WizButton
                text={'Reset'}
                className={'text-white'}
                type={'blue'}
                size={'small'}
                onClick={() => {
                    onClick('')
                    setInputText('')
                }}
            />
        </div>
    )
}

export default UserSearchContainer
